import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import params from '../config/Params';
import { getItemFromLocalStorage } from '../utils/storageUtils';
import { toast } from 'react-toastify';

const Payment = () => {
  const navigate = useNavigate();
  const listingId = 1;
  const [bankList, setBankList] = useState([]);
  const [selectedBank, setSelectedBank] = useState(null);
  const [ownershipDoc, setOwnershipDoc] = useState('');
  const [ownerDoc, setOwnerDoc] = useState('');
  const [accountHolderName, setAccountHolderName] = useState('');
  const [accountNumber, setAccountNumber] = useState('');
  const [reAccountNumber, setReAccountNumber] = useState('');
  const [isMatch, setIsMatch] = useState(null);
  const [ifscNumber, setIfscNumber] = useState('');
  const [isIfscValid, setIsIfscValid] = useState(null);
  const [bankName, setBankName] = useState('');
  const [isGstin, setIsGstin] = useState(1);
  const [gstNumber, setGstNumber] = useState('');
  const [panNumber, setPanNumber] = useState('');
  const [isTanNumber, setIsTanNumber] = useState(1);
  const [tanNumber, setTanNumber] = useState('');
  const [isGstValid, setIsGstValid] = useState(null);
  const [isPanValid, setIsPanValid] = useState(null);
  const [isTanValid, setIsTanValid] = useState(null);
  const [errors, setErrors] = useState({});
  const [activeIndex, setActiveIndex] = useState(null);

  const [searchTerm, setSearchTerm] = useState("");
  const [filteredBanks, setFilteredBanks] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isBankListVisible, setIsBankListVisible] = useState(true);

  useEffect(() => {
    const fetchLegal = async () => {
      const hostData = getItemFromLocalStorage('hostProfile');
      let formData = new FormData();
      formData.append("token", hostData.host_access_token);

      try {
        const response = await axios({
          method: 'post',
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          url: `${params.baseURL}${params.endpoints.getLegal}`,
          data: formData,
        });

        if (response.data.status === "ok") {
          const data = response.data.updated_property_item;
          setOwnershipDoc(data.ownership_document);
          setAccountHolderName(data.bank_account_holder_name);
          setAccountNumber(data.owner_bank_account_number);
          setReAccountNumber(data.owner_bank_account_number);
          setIfscNumber(data.owner_bank_ifsc_number);
          setBankName(data.owner_bank_name);
          setIsGstin(data.is_gstin);
          setGstNumber(data.gstin_number);
          setPanNumber(data.pan_number);
          setIsTanNumber(data.is_tan_number);
          setTanNumber(data.tan_number);
          setOwnerDoc(data.ownership_document_url);
        } else {
          //toast.error("Failed to fetch policies data.");
        }
      } catch (error) {
        //toast.error("An error occurred while fetching data.");
        console.error(error);
      }
    };

    const fetchHotelData = async () => {
      const hostData = getItemFromLocalStorage('hostProfile');
      let formData = new FormData();
      formData.append('token', hostData.host_access_token);
      formData.append('listing_id', listingId);
  
      try {
        const response = await axios({
          method: 'post',
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          url: `${params.baseURL}${params.endpoints.hotelDataList}`,
          data: formData,
        });
  
        if (response.data.status === 'ok') {
          const dataList = response.data.list;
        } else {
          toast.error('An error occurred while fetching data.');
        }
      } catch (err) {
        console.log(err.message);
      }
    };

    const fetchBankList = async () => {
      const hostData = getItemFromLocalStorage('hostProfile');
      let formData = new FormData();
      formData.append('token', hostData.host_access_token);
  
      try {
        const response = await axios({
          method: 'post',
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          url: `${params.baseURL}${params.endpoints.getBankList}`,
          data: formData,
        });
  
        if (response.data.status === 'ok') {
          setBankList(response.data.bank_list);
          setFilteredBanks(response.data.bank_list);
        } else {
          toast.error('An error occurred while fetching data.');
        }
      } catch (err) {
        console.log(err.message);
      }
    };

    fetchLegal();
    fetchHotelData();
    fetchBankList();
  }, [listingId, params]);

  const handleBankClick = (bank) => {
    setSelectedBank(bank);
    setBankName(bank.bank_name);
    setIsBankListVisible(false);
  };

  const handleSearchChange = (e) => {
    const term = e.target.value;
    setSearchTerm(term);

    const filtered = bankList.filter((bank) =>
      bank.bank_name.toLowerCase().includes(term.toLowerCase())
    );
    setFilteredBanks(filtered);
    setShowDropdown(true);
  };

  const handleSelectBank = (bank) => {
    handleBankClick(bank);
    setSearchTerm(bank.bank_name);
    //setShowDropdown(false);
  };

  const validateField = (field, value) => {
    const errors = {};
  
    switch (field) {
      case 'accountNumber':
        if (!value || value.length < 10) {
          errors[field] = 'Invalid account number. It must be at least 10 characters.';
        }
        break;
      case 'reAccountNumber':
        if (value !== accountNumber) {
          errors[field] = 'Account numbers do not match!';
        }
        break;
      case 'ifscNumber':
        const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
        if (!value || !ifscRegex.test(value)) {
          errors[field] = 'Invalid IFSC code.';
        }
        break;
      case 'gstNumber':
        const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{3}$/;
        if (!value || !gstRegex.test(value)) {
          errors[field] = 'Invalid GSTIN. It must be 15 characters.';
        }
        break;
      case 'panNumber':
        const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
        if (!value || !panRegex.test(value)) {
          errors[field] = 'Invalid PAN. It must be 10 characters.';
        }
        break;
      case 'tanNumber':
        const tanRegex = /^[A-Z]{4}[0-9]{5}[A-Z]$/;
        if (!value || !tanRegex.test(value)) {
          errors[field] = 'Invalid TAN. It must be 10 characters.';
        }
        break;
      case 'bankName':
        if (!value || value.trim() === '') {
          errors[field] = 'Bank name is required.';
        }
        break;
      case 'accountHolderName':
        if (!value || value.trim() === '') {
          errors[field] = 'Account holder name is required.';
        }
        break;
      default:
        break;
    }
  
    return errors;
  };
  
  const handleInputChange = (field, value) => {
    const updatedErrors = { ...errors };
    delete updatedErrors[field];
  
    const fieldErrors = validateField(field, value);
  
    setErrors({ ...updatedErrors, ...fieldErrors });
  
    // Update the corresponding state
    switch (field) {
      case 'accountNumber':
        setAccountNumber(value);
        break;
      case 'reAccountNumber':
        setReAccountNumber(value);
        break;
      case 'ifscNumber':
        setIfscNumber(value);
        break;
      case 'gstNumber':
        setGstNumber(value);
        break;
      case 'panNumber':
        setPanNumber(value);
        break;
      case 'tanNumber':
        setTanNumber(value);
        break;
      case 'bankName':
        setBankName(value);
        break;
      case 'accountHolderName':
        setAccountHolderName(value);
        break;
      default:
        break;
    }
  };
  
  const validateInputs = () => {
    const fieldsToValidate = [
      { field: 'accountNumber', value: accountNumber },
      { field: 'reAccountNumber', value: reAccountNumber },
      { field: 'ifscNumber', value: ifscNumber },
      { field: 'panNumber', value: panNumber },
      { field: 'bankName', value: bankName },
      { field: 'accountHolderName', value: accountHolderName },
    ];

    if (isGstin === 1) {
      fieldsToValidate.push({ field: 'gstNumber', value: gstNumber });
    }
  
    if (isTanNumber === 1) {
      fieldsToValidate.push({ field: 'tanNumber', value: tanNumber });
    }
  
    const validationErrors = fieldsToValidate.reduce((acc, { field, value }) => {
      const errors = validateField(field, value);
      return { ...acc, ...errors };
    }, {});
  
    setErrors(validationErrors);
  
    return Object.keys(validationErrors).length === 0;
  };  

  const saveData = async () => {
    if (!validateInputs()) {
      toast.error("Please fill all mandatory fields.");
      return;
    }
    const hostData = getItemFromLocalStorage('hostProfile');
    const legalData = [{
      stay_listing_id : listingId,
      //ownership_document : ownershipDoc,
      bank_account_holder_name : accountHolderName,
      owner_bank_account_number : accountNumber,
      owner_bank_ifsc_number : ifscNumber,
      owner_bank_name : bankName,
      is_gstin : isGstin,
      gstin_number : gstNumber,
      pan_number : panNumber,
      is_tan_number : isTanNumber,
      tan_number : tanNumber
    }];

    let formData = new FormData();
    formData.append("token", hostData.host_access_token);
    formData.append("listing_id", listingId);
    formData.append("data", JSON.stringify({ legal: legalData }));

    try {
      const response = await axios({
        method: 'post',
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        url: `${params.baseURL}${params.endpoints.updateLegal}`,
        data: formData,
      });

      if (response.data.status === "done") {
        toast.success("Legal Details updated successfully!");
        navigate('/payment');
      } else {
        toast.error("Failed to save policies.");
      }
    } catch (error) {
      toast.error("An error occurred while saving policies.");
      console.error(error);
    }
  };

  const handleNext = () => {
    saveData();
  };

  return (
    <div>
        <div className="hotel-register-section legal-section">
          <div className='row'>
                <div className='col-md-4 listing-img-box'>
                    <div>
                        <img src={'/assets/img/banners/manage_calendar_banner.webp'} alt="Listing Image" className="listing-image" />
                    </div>
                </div>
                <div className='col-md-8 offset-md-4'>

                    {ownerDoc && ownerDoc.length > 0 && (
                      <div className="doc-detail-box">
                        <h6 style={{ fontWeight: '800', marginBottom: '10px', textTransform: 'uppercase' }}>HOST ACCOUNT HOLDER - </h6>
                        <div className='grid-container'>
                          {ownerDoc.map((doc, index) => (
                            <a key={index} style={{ marginBottom: '8px' }} href={doc.url} target="_blank" rel="noopener noreferrer" className='grid-item'>
                              <div>{doc.title}</div>
                              <span className='view-doc-icon'>
                                <img src={'/assets/img/icons/doc_view_icon.png'} alt="Listing Image" className="img-fluid" />
                              </span>
                            </a>
                          ))}
                        </div>
                      </div>
                    )}

                    <div className="add-room-section">
                        <div className="room-detail-box">
                        <div>
                            <p className='rdb-title mb-0'>Banking Details</p>
                            <p className="label-hint">Enter Bank, PAN & GST Details</p>
                        </div>
                        <div className='row'>

                            <div className="bank-search-bar px-0">
                            <div className='itwac'>
                                {/*<img src={'/assets/img/icons/legal_pointer_icon.png'} alt="Profile" className="form-icon" />*/}
                                <input
                                type="text"
                                value={searchTerm}
                                onChange={handleSearchChange}
                                placeholder="search bank"
                                className="form-control"
                                onFocus={() => {
                                    setShowDropdown(true);
                                    setIsBankListVisible(false);
                                }}
                                //onBlur={() => setTimeout(() => setShowDropdown(false), 200)}
                                />
                            </div>

                            {showDropdown && (
                                <div className="star-rating-popup">
                                <div className='star-popup-content'>
                                    <div>
                                    <input
                                        type="text"
                                        value={searchTerm}
                                        onChange={handleSearchChange}
                                        placeholder="search bank"
                                        className="form-control"
                                        style={{marginBottom:'1rem'}}
                                        onFocus={() => {
                                        setShowDropdown(true);
                                        setIsBankListVisible(false);
                                        }}
                                        //onBlur={() => setTimeout(() => setShowDropdown(false), 200)}
                                    />
                                    </div>
                                    <div className='banklist-popup-section'>
                                    {filteredBanks.length > 0 ? (
                                        filteredBanks.map((bank) => (
                                        <div
                                            key={bank.bank_id}
                                            className="bank-dropdown-item"
                                            onClick={() => handleSelectBank(bank)}                    
                                            aria-label={`Select ${bank.bank_name}`}
                                        >
                                            <div className='dbank-img-box'>
                                            <img src={bank.bank_image_url} className='img-fluid dbank-icon' />
                                            <div class="tooltiptext">{bank.bank_full_name}</div>
                                            </div>
                                        </div>
                                        ))
                                    ) : (
                                        <div className="dropdown-item">No banks found</div>
                                    )}
                                    </div>
                                    <div className='banklist-popup-footer'>
                                    <button className='pp-btn btn-cancel' onClick={() => setShowDropdown(false)}>Close</button>
                                    <button
                                        className='pp-btn btn-done'
                                        onClick={() => {
                                        if (searchTerm) {
                                            setShowDropdown(false);
                                        } else {
                                            alert('Please select a bank.');
                                        }
                                        }}
                                    >
                                        Done
                                    </button>
                                    </div>
                                </div>
                                </div>
                            )}
                            </div>

                            {isBankListVisible && (
                            <div className="bank-list px-0">
                            <p className='rdb-title'>Choose bank</p>
                            <div className="bank-list-section">
                                {bankList.map((bank) => (
                                <div key={bank.bank_id} className="bank-list-box">
                                    <div
                                    className='bank-it-section'
                                    onClick={() => {
                                        handleBankClick(bank);
                                        setIsBankListVisible(false);
                                    }}
                                    aria-label={`Select ${bank.bank_name}`}
                                    >
                                    <div className='dbank-img-box'>
                                        <img src={bank.bank_image_url} className='img-fluid dbank-icon' />
                                        <div class="tooltiptext">{bank.bank_full_name}</div>
                                    </div>
                                    <span>{bank.bank_name}</span>
                                    </div>
                                </div>
                                ))}
                            </div>
                            </div>
                            )}

                            {selectedBank && (
                            <div className="bank-details-form">
                                <div className='selected-bank-details'>
                                <img src={selectedBank.bank_image_url} className='img-fluid' />
                                <span>{selectedBank.bank_name}</span>
                                </div>
                                <div className="row">  
                                  <div className='col-md-6'>
                                      <div className="form-box">
                                      <label for="bankName" class="form-label">Bank Name</label>
                                      <div className='itwac'>
                                          <img src={'/assets/img/icons/legal_pointer_icon.png'} alt="Profile" className="form-icon" />
                                          <input type="text" class="form-control" id="bankName" placeholder="Enter Bank Name" value={bankName} 
                                          onChange={(e) => handleInputChange('bankName', e.target.value)}
                                      />
                                      </div>
                                      {errors.bankName && <div className="error-text">{errors.bankName}</div>}
                                      </div>
                                  </div>
                                  <div className='col-md-6'>
                                      <div className="form-box">
                                      <label for="accountHolderName" class="form-label">Account Holder Name</label>
                                      <div className='itwac'>
                                          <img src={'/assets/img/icons/legal_pointer_icon.png'} alt="Profile" className="form-icon" />
                                          <input type="text" class="form-control" id="accountHolderName" placeholder="Enter Account Holder Name" value={accountHolderName} 
                                          onChange={(e) => handleInputChange('accountHolderName', e.target.value)}
                                      />
                                      </div>
                                      {errors.accountHolderName && <div className="error-text">{errors.accountHolderName}</div>}
                                      </div>
                                  </div>
                                  <div className="col-md-6">
                                      <div className="form-box">
                                      <label htmlFor="accountNumber" className="form-label">
                                          Account Number
                                      </label>
                                      <div className='itwac'>
                                          <img src={'/assets/img/icons/legal_pointer_icon.png'} alt="Profile" className="form-icon" />
                                          <input
                                          type="text"
                                          className="form-control"
                                          id="accountNumber"
                                          placeholder="Enter Account Number"
                                          value={accountNumber}
                                          onChange={(e) => setAccountNumber(e.target.value)}
                                          onPaste={(e) => e.preventDefault()}
                                          required
                                          />
                                      </div>
                                      {errors.accountNumber && (
                                          <div className="error-text">{errors.accountNumber}</div>
                                      )}
                                      </div>
                                  </div>
                                  <div className="col-md-6">
                                      <div className="form-box">
                                      <label htmlFor="reAccountNumber" className="form-label">
                                          Re-enter Account Number
                                      </label>
                                      <div className='itwac'>
                                          <img src={'/assets/img/icons/legal_pointer_icon.png'} alt="Profile" className="form-icon" />
                                          <input
                                          type="text"
                                          className={`form-control ${
                                              isMatch === false ? "is-invalid" : ""
                                          }`}
                                          id="reAccountNumber"
                                          placeholder="Re-enter Account Number"
                                          value={reAccountNumber}
                                          onChange={(e) => {
                                              setReAccountNumber(e.target.value);
                                              setIsMatch(e.target.value === accountNumber);
                                          }}
                                          onPaste={(e) => e.preventDefault()}
                                          />
                                      </div>
                                      {isMatch === false && (
                                          <div className="invalid-feedback">
                                          Account numbers do not match!
                                          </div>
                                      )}
                                      {errors.reAccountNumber && (
                                          <div className="error-text">{errors.reAccountNumber}</div>
                                      )}
                                      </div>
                                  </div>
                                  <div className="col-md-6">
                                      <div className="form-box">
                                      <label htmlFor="ifsc" className="form-label">
                                          IFSC Number
                                      </label>
                                      <div className='itwac'>
                                          <img src={'/assets/img/icons/legal_pointer_icon.png'} alt="Profile" className="form-icon" />
                                          <input
                                          type="text"
                                          className={`form-control ${
                                              isIfscValid === false ? "is-invalid" : ""
                                          }`}
                                          id="ifsc"
                                          placeholder="Enter IFSC Number"
                                          value={ifscNumber}
                                          onChange={(e) => setIfscNumber(e.target.value)}
                                          />
                                      </div>
                                      {isIfscValid === false && (
                                          <div className="invalid-feedback">
                                          Please enter a valid IFSC code.
                                          </div>
                                      )}
                                      </div>
                                  </div>
                                </div>
                            </div>
                            )}
                        </div>

                        <span className='line'></span>

                        <div className="room-detail-box">
                            <div className='dypxbs'>
                                <div>
                                    <p>Do you have a GSTIN?</p>
                                </div>
                                <div class="extra-bed-radio">
                                    <div className='exdrs'>
                                    <label>
                                        <input type="radio" name="isGstin" value="2" checked={isGstin === 2} onChange={() => setIsGstin(2)} />
                                        <span>No</span>
                                    </label>
                                    <label>
                                        <input type="radio" name="isGstin" value="1" checked={isGstin === 1} onChange={() => setIsGstin(1)} />
                                        <span>Yes</span>
                                    </label>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                            {isGstin === 1 && (
                                <div className='col-md-6 ps-0'>
                                <div className="form-box">
                                    <label htmlFor="gstin" className="form-label">Enter GSTIN</label>
                                    <div className='itwac'>
                                    <img src={'/assets/img/icons/legal_pointer_icon.png'} alt="Profile" className="form-icon" />
                                    <input 
                                        type="text" 
                                        className={`form-control ${isGstValid === false ? 'is-invalid' : ''}`} 
                                        id="gstin" 
                                        placeholder="Enter the 15 digit GSTIN" 
                                        value={gstNumber} 
                                        onChange={(e) => handleInputChange('gstNumber', e.target.value)}
                                    />
                                    </div>
                                    {isGstValid === false && (
                                    <div className="invalid-feedback">Please enter a valid GSTIN (15 characters).</div>
                                    )}
                                    {errors.gstNumber && <div className="error-text">{errors.gstNumber}</div>}
                                </div>
                                </div>
                            )}
                            <div className='col-md-6 pe-0'>
                                <div className="form-box">
                                <label htmlFor="pancard" className="form-label">Enter PAN</label>
                                <div className='itwac'>
                                    <img src={'/assets/img/icons/legal_pointer_icon.png'} alt="Profile" className="form-icon" />
                                    <input 
                                    type="text" 
                                    className={`form-control ${isPanValid === false ? 'is-invalid' : ''}`} 
                                    id="pancard" 
                                    placeholder="Enter PAN" 
                                    value={panNumber} 
                                    onChange={(e) => handleInputChange('panNumber', e.target.value)}
                                    />
                                </div>
                                {isPanValid === false && (
                                    <div className="invalid-feedback">Please enter a valid PAN (10 characters).</div>
                                )}
                                {errors.panNumber && <div className="error-text">{errors.panNumber}</div>}
                                </div>
                            </div>
                            </div>
                        </div>

                            <span className='line'></span>

                            <div className="room-detail-box">
                                <div className='dypxbs'>
                                <div>
                                    <p>Do you have a TAN?</p>
                                </div>
                                <div class="extra-bed-radio">
                                    <div className='exdrs'>
                                    <label>
                                        <input type="radio" name="isTanNumber" value="2" checked={isTanNumber === 2} onChange={() => setIsTanNumber(2)} />
                                        <span>No</span>
                                    </label>
                                    <label>
                                        <input type="radio" name="isTanNumber" value="1" checked={isTanNumber === 1} onChange={() => setIsTanNumber(1)} />
                                        <span>Yes</span>
                                    </label>
                                    </div>
                                </div>
                                </div>
                                {isTanNumber === 1 && (
                                <div className="row">
                                    <div className="col-md-6 ps-0">
                                    <div className="form-box">
                                        <label htmlFor="tanNumber" className="form-label">Enter TAN</label>
                                        <div className='itwac'>
                                        <img src={'/assets/img/icons/legal_pointer_icon.png'} alt="Profile" className="form-icon" />
                                        <input 
                                            type="text" 
                                            className={`form-control ${isTanValid === false ? 'is-invalid' : ''}`} 
                                            id="tanNumber" 
                                            placeholder="Enter the 10 digit TAN" 
                                            value={tanNumber} 
                                            onChange={(e) => handleInputChange('tanNumber', e.target.value)}
                                        />
                                        </div>
                                        {isTanValid === false && (
                                        <div className="invalid-feedback">Please enter a valid TAN (10 characters).</div>
                                        )}
                                        {errors.tanNumber && <div className="error-text">{errors.tanNumber}</div>}
                                    </div>
                                    </div>
                                </div>
                                )}
                            </div>
                        </div>
                    </div>
                    
                    <div className="form-button mt-3">
                        <button className='btn btn-black w-100' onClick={handleNext}>Submit</button>
                    </div>
                </div>
          </div>
        </div>

    </div>
  );
};

export default Payment;
